import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Trash2, ShoppingBag, ArrowRight, Minus, Plus } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { baseURL } from '../../utils/api';
import './Cart.css';

const Cart = () => {
    const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();
    const navigate = useNavigate();

    const subtotal = getCartTotal();
    const shipping = subtotal > 0 ? 250 : 0;
    const total = subtotal + shipping;

    if (cartItems.length === 0) {
        return (
            <div className="ec-cart-empty">
                <div className="ec-empty-icon">
                    <ShoppingBag size={64} />
                </div>
                <h2>Your cart is empty</h2>
                <p>Looks like you haven't added anything to your cart yet.</p>
                <Link to="/shop" className="ec-btn ec-btn--primary">
                    Start Shopping
                </Link>
            </div>
        );
    }

    return (
        <div className="ec-cart-root">
            <div className="ec-cart-container">
                <header className="ec-cart-header">
                    <h1>Shopping Cart</h1>
                    <p>{cartItems.length} items in your cart</p>
                </header>

                <div className="ec-cart-grid">
                    {/* Items List */}
                    <div className="ec-cart-items">
                        {cartItems.map(item => (
                            <div key={item.id} className="ec-cart-item">
                                <Link to={`/product/${item.slug}`} className="ec-item-img">
                                    <img src={item.image ? (item.image.startsWith('http') ? item.image : `${baseURL}${item.image}`) : 'https://via.placeholder.com/150'} alt={item.name} />
                                </Link>
                                <div className="ec-item-details">
                                    <div className="ec-item-header">
                                        <Link to={`/product/${item.slug}`} className="ec-item-name">{item.name}</Link>
                                        <button 
                                            className="ec-remove-btn"
                                            onClick={() => removeFromCart(item.id)}
                                        >
                                            <Trash2 size={18} />
                                        </button>
                                    </div>
                                    <span className="ec-item-cat">{item.category}</span>
                                    
                                    <div className="ec-item-footer">
                                        <div className="ec-item-quantity">
                                            <button onClick={() => updateQuantity(item.id, item.quantity - 1)}><Minus size={14} /></button>
                                            <span>{item.quantity}</span>
                                            <button onClick={() => updateQuantity(item.id, item.quantity + 1)}><Plus size={14} /></button>
                                        </div>
                                        <div className="ec-item-price">
                                            Rs. {(item.price * item.quantity).toLocaleString()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Summary Sidebar */}
                    <aside className="ec-cart-summary">
                        <h3>Order Summary</h3>
                        <div className="ec-summary-rows">
                            <div className="ec-summary-row">
                                <span>Subtotal</span>
                                <span>Rs. {subtotal.toLocaleString()}</span>
                            </div>
                            <div className="ec-summary-row">
                                <span>Shipping Fee</span>
                                <span>Rs. {shipping.toLocaleString()}</span>
                            </div>
                            <div className="ec-summary-row ec-row-total">
                                <span>Total</span>
                                <span>Rs. {total.toLocaleString()}</span>
                            </div>
                        </div>

                        <div className="ec-checkout-perks">
                            <p>• Secured checkout with SSL</p>
                            <p>• Cash on Delivery available</p>
                        </div>

                        <button 
                            className="ec-checkout-btn"
                            onClick={() => navigate('/checkout')}
                        >
                            Proceed to Checkout <ArrowRight size={18} />
                        </button>
                    </aside>
                </div>
            </div>
        </div>
    );
};

export default Cart;
